import Vue from 'vue'
import App from './App.vue'
import './plugins/element'
import router from './router'
import Print from 'vue-print-nb'
import axios from './plugins/axios.js'
import store from './store'
import './utils/dialog'
import './quasar'
// import './plugins/ant'

Vue.prototype.$axios = axios;

Vue.use(Print);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
